import React from 'react'
import { useTranslation } from 'react-i18next';

function SocialEntrepreneurship() {
  const { t } = useTranslation();

  return (
    <div>
      <section>
        <div className='relative'>
          <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/25708212d8c5e137294fe7ba0ad7baae4ce269c444086d80c0cdc85e602a4f8e5184556e4a039c3d9b54f528894634179c4925716df56a1400eb9db3ef2ebed69675bd481f55d5c33cec7892e2dd4b7f0d3025a58549e877d0a6b4d6afb885378ef627df505e501bc008c01cfca3a2046fd1ecd43c1afcacd8a4/rez-file-1739775349512.jpg" alt="main" className='w-full max-h-40 sm:max-h-80 object-cover object-bottom' />
          <div className='absolute top-0 bottom-0 left-0 right-0 bg-app-orange/10 text-white'>
            <div className='app-main-container flex flex-col justify-center items-center h-full gap-4 sm:gap-8'>
              <p className='text-xl/[2rem] sm:text-3xl/[4rem] lg:text-5xl/[5rem] max-w-6xl px-8 font-semibold sm:font-bold text-center app-animation-translate-start'>Social Entrepreneurship Workshop & Inhouse Trainings</p>
            </div>
          </div>
        </div>
      </section>

      <section className='bg-app-light-gray/10'>
        <div className='app-main-container space-y-8'>
          <p className='py-3 md:py-6 text-base/[1.75rem] md:text-lg/[2rem] xl:text-xl/[2.5rem] text-center app-animation-translate-start'>
            Our <b>Social Entrepreneurship Workshops & In-House Training</b> programs are designed to equip individuals, businesses, and organizations with the <b>skills, strategies, and mindset</b> needed to create <b>impact-driven ventures</b> that address social and environmental challenges. Whether you're an entrepreneur, educator, corporate leader, or nonprofit professional, our expert-led sessions will help you <b>develop sustainable business models, drive innovation, and scale social impact.</b>
          </p>
        </div>
      </section>

      <section>
        <div className='app-main-container space-y-8'>
          <p className='pt-3 pb-2 md:pt-6 md:pb-4 text-xl md:text-2xl xl:text-4xl font-bold text-app-orange text-center app-animation-translate-start'>
            Social Entrepreneurship Workshop & Inhouse Trainings
          </p>
          <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/8f9592f5c662b706fc62e7146512e3c8a5633ffb8ae9896c0cabcc1d98a09f3ca56e2c218044cca4e17b771a38a0e646d83c5007687dca62424a4b43765db769bb71eacf33ee33453bc07a67634488847e1146eb37a5c354e07e26dba1245667bfb7c0af40b16005aaff94c6b7ebac18f5b0c3b0fc87a0ab5137/rez-file-1739259035432.png" alt="main" className='pt-4 pb-8 w-4/5 sm:w-3/5 mx-auto object-cover object-center app-animation-scale-start' />
        </div>
      </section>
    </div>
  )
}

export default SocialEntrepreneurship